import React, { useEffect, useState, useRef } from "react";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { get } from "../../helpers/api_helper";
import { isMobile } from 'react-device-detect';
import { TIME_FIELD_INVENTORY, TIME_FIELD_TITLE_INVENTORY } from '../../constants';
import toastr from "toastr";
import { useSearchParams } from "react-router";

import {
  Modal,
  ModalHeader,
  Input,
  Button,
  CardImg,
  CardTitle,
  Card,
  CardBody,
  Col,
  Row,
  Label,
  Badge,
  ModalBody,
} from "reactstrap";
import './get-scan-inventory.scss';
import { CardInfoGetScanInventory } from "./card-info-get-scan-inventory";



const ScanInventory = () => {
  const clearSortTyping = useRef();
  const inputRef = useRef();
  const [billId, setBillId] = useState('');
  const [loading, setLoading] = useState(false);
  const [history, setHistory] = useState([]);
  const [countScanInventory, setCountScanInventory] = useState({});
  const [searchParams, setSearchParams] = useSearchParams();
  const searchQuery = searchParams.get('q');

  useEffect(() => {
    inputRef?.current?.focus();
    getCountScanInventory();
    setInterval(() => {
      getCountScanInventory();

    }, 5000)
  }, [])

  // Tìm kiếm từ ô search trên header (?q=mã đơn)
  useEffect(() => {
    if (searchQuery) {
      save(searchQuery.trim());
      setSearchParams({}, { replace: true });
    }
  }, [searchQuery])

  const onChangeBillId = (id) => {
    setBillId(id);
  }

  const getCountScanInventory = () => {
    get(`/bills/count-scan-inventory`, {}, {})
      .then((result) => {
        console.log(result);
        setCountScanInventory(result)
      })
  }
  const save = (id) => {
    if (id === '') {
      return;
    }
    clearTimeout(clearSortTyping.current);
    setLoading(true)
    get(`/bills/get-scan-inventory/${id}`, {}, {})
      .then((result) => {
        setHistory(result)
        if (result.length === 0) {
          toastr.error('Không tìm thấy đơn hàng');
        }
      })
      .catch(e => {
        setHistory([{
          billId: id,
          status: 0,
          message: [{ msg: e.error, color: 'danger' }]
        }])
      })
      .finally(() => {
        setBillId('');
        setLoading(false);
        inputRef?.current?.focus();
      })
  }


  return <div className="page-content page-product">
    <Breadcrumbs title="Đơn hàng" breadcrumbItem="Quét đơn" />
    <Row className="scan-inventory">
      <Col md={12} xs={12}>
        <div>
          <Row className="get-scan-inventory d-flex justify-content-center">
            <Col md={3} xs={12}>
              <ul>
                <li>
                  <b>{TIME_FIELD_TITLE_INVENTORY[TIME_FIELD_INVENTORY.WAITING_EXPORT_VAT]}</b>: <strong className="fs-24">{countScanInventory[TIME_FIELD_INVENTORY.WAITING_EXPORT_VAT]}</strong>
                </li>
                <li>
                  <b>{TIME_FIELD_TITLE_INVENTORY[TIME_FIELD_INVENTORY.PREPARING]}</b>: <strong className="fs-24">{countScanInventory[TIME_FIELD_INVENTORY.PREPARING]}</strong>
                </li>
                <li>
                  <b>{TIME_FIELD_TITLE_INVENTORY[TIME_FIELD_INVENTORY.CHECK_PACKAGE]}</b>: <strong className="fs-24">{countScanInventory[TIME_FIELD_INVENTORY.CHECK_PACKAGE]}</strong>
                </li>
                <li>
                  <b>{TIME_FIELD_TITLE_INVENTORY[TIME_FIELD_INVENTORY.IN_PACKAGE]}</b>: <strong className="fs-24">{countScanInventory[TIME_FIELD_INVENTORY.IN_PACKAGE]}</strong>
                </li>
                <li>
                  <b>{TIME_FIELD_TITLE_INVENTORY[TIME_FIELD_INVENTORY.TO_SHIPPER]}</b>: <strong className="fs-24">{countScanInventory[TIME_FIELD_INVENTORY.TO_SHIPPER]}</strong>
                </li>
              </ul>
            </Col>
            <Col md={6} xs={12}>
              <h4>Quét tìm đơn hàng</h4>
              <form className="get-scan-inventory_input" onSubmit={(e) => {
                e.preventDefault();
                save(billId)
              }}>
                <input
                  ref={inputRef}
                  disabled={loading}
                  value={billId}
                  onChange={(e) => {
                    onChangeBillId(e.target.value)
                  }}
                  onKeyup={(event) => {
                    const code = event.code;
                    const key = event.keyCode || event.which
                    if (code === "Enter" || code === "NumpadEnter" || key === '13') {
                      event.preventDefault();
                      save(billId);
                    }
                  }}
                  onBlur={(e) => {
                    // Không giành lại focus khi người dùng chuyển sang ô input khác (vd: ô search trên header)
                    if (!isMobile && e.relatedTarget?.tagName !== 'INPUT') {
                      inputRef?.current?.focus();
                    }
                  }}
                  placeholder="Nhập mã đơn hàng"
                />
                <span className="get-scan-inventory_input_icon" onClick={() => save(billId)}><i className="fa fa-search"></i></span>
              </form>
            </Col>
            <Col md={3} xs={0}></Col>
          </Row>
          <hr />
          <h4>Kết quả</h4>
          <div className="get-scan-inventory_history">
            <Row >
              {history.map((e, i) =>
                <Col key={i} md={6}>
                  <CardInfoGetScanInventory data={e} />
                </Col>
              )}
            </Row>
          </div>


        </div>
      </Col>
    </Row>
  </div>
}

export default ScanInventory